<p-toast></p-toast>
<p-dialog
  [(visible)]="showSessionAttendeesEnrollModal"
  [style]="{ width: '35vw',height: '45vh'  }"
  (onHide)="closeModal()"
  [modal]="true"
  id="requestEffectiveDateModal"
>
<ng-template pTemplate="header">
  <div>
    Select Attendees
  </div>
</ng-template>
<div class="m-2">
  <bpt-dropdown
    label="Attendees"
    [options]="usersList"
    [(ngModel)]="selectedAttendees"
    (ngModelChange)="onAttendeeChange()"
    [editable]="false"
    placeholder="Select Attendees"
    id="sessionAttendeesEnrollment"
    [showClear]="true"
    [showFilter]="true"
    [valueField]="valueField"
    [labelField]="labelField"
    [multiSelect]="true"
    [showHeader]="true"
    [showToggleAll]="false"
  >
  </bpt-dropdown>
</div>
<div class="m-2">{{maxAttendeesConstant}}</div>

  <ng-template pTemplate="footer">
    <p-button
      styleClass="p-button-outlined"
      label="Cancel"
      type="cancel"
      id="sessionAttendeesEnrollmentCancelBtn"
      class="align-right"
      (onClick)="closeModal()"
    >
    </p-button>
    <p-button
  label="Confirm"
  type="submit"
  id="sessionAttendeesEnrollmentConfirmBtn"
  class="align-right"
  [disabled]="!selectedAttendees || selectedAttendees.length === 0"
  (onClick)="addSessionAttendees()"
>
</p-button>

  </ng-template>
</p-dialog>
